(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password-template"]) return;
  try {
    
    document.getElementById('open-modal').onclick = function() {
      document.getElementById('store-password').showModal();
    };
    document.getElementById('close-modal').onclick = function() {
      document.getElementById('store-password').close();
    };
  
  } catch(e) { console.error(e); }
})();
})();
